<template>
	<div>
		<box :ref="boxRef" title="选择供应商" :width="1000" :index="0" moduleName="supplier" @hide="hide"
			@submit="submit" group="supplier" :store="store" selectType="radio" @boxdataload="boxdataload" />
	</div>
</template>
<style scoped>

</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				index:0,
				foreingKey: {},
				boxRef: 'box_' + Math.random(),
				box: null
			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			
			this.box = box

		},
		watch: {

		},
		computed: {
			device(){
				return window.systemMethods.device()
			}
		},
		methods: {
			boxdataload(e){
				this.$emit('boxdataload',e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>
